import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import calls from './calls.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import supportWidget from './supportWidget.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import sessionLimit from './sessionLimit.json';
import yearInReview from './yearInReview.json';
import jabvoxKanban from './jabvoxKanban.json';
import jabvoxProducts from './jabvoxProducts.json';
import jabvoxVoip from './jabvoxVoip.json';
import jabvoxCdr from './jabvoxCdr.json';
import jabvoxAudioAnalysis from './jabvoxAudioAnalysis.json';
import jabvoxAnalytics from './jabvoxAnalytics.json';
import jabvoxTasks from './jabvoxTasks.json';
import jabvoxSaldo from './jabvoxSaldo.json';
import jabvoxAiBudget from './jabvoxAiBudget.json';
import jabvoxSms from './jabvoxSms.json';
import jabvoxIpWhitelist from './jabvoxIpWhitelist.json';
import jabvoxAiChat from './jabvoxAiChat.json';
import jabvoxProvisioningChat from './jabvoxProvisioningChat.json';
import jabvoxManagementStates from './jabvoxManagementStates.json';
import jabvoxDialer from './jabvoxDialer.json';
import jabvoxFieldSecurity from './jabvoxFieldSecurity.json';
import jabvoxContacts from './jabvoxContacts.json';
import jabvoxLeads from './jabvoxLeads.json';
import jabvoxAffiliates from './jabvoxAffiliates.json';
import jabvoxAffiliatePortal from './jabvoxAffiliatePortal.json';
import jabvoxCalendar from './jabvoxCalendar.json';
import jabvoxInternalChat from './jabvoxInternalChat.json';
import jabvoxReports from './jabvoxReports.json';
import jabvoxEmail from './jabvoxEmail.json';
import jabvoxActions from './jabvoxActions.json';
import jabvoxBilling from './jabvoxBilling.json';
import jabvoxForms from './jabvoxForms.json';
import jabvoxCustomization from './jabvoxCustomization.json';
import jabvoxClickToCall from './jabvoxClickToCall.json';
import jabvoxSoftphone from './jabvoxSoftphone.json';
import jabvoxWhatsappTemplates from './jabvoxWhatsappTemplates.json';
import jabvoxWhatsappFlows from './jabvoxWhatsappFlows.json';
import jabvoxBulkWhatsapp from './jabvoxBulkWhatsapp.json';
import jabvoxWhatsappGroups from './jabvoxWhatsappGroups.json';
import jabvoxVoiceBroadcast from './jabvoxVoiceBroadcast.json';
import jabvoxTickets from './jabvoxTickets.json';
import jabvoxLeadImport from './jabvoxLeadImport.json';
import jabvoxDataExport from './jabvoxDataExport.json';
import jabvoxAdvancedAutomations from './jabvoxAdvancedAutomations.json';
import jabvoxClinica from './jabvoxClinica.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...calls,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...supportWidget,
  ...snooze,
  ...teamsSettings,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  ...onboarding,
  ...sessionLimit,
  ...yearInReview,
  ...jabvoxKanban,
  ...jabvoxProducts,
  ...jabvoxVoip,
  ...jabvoxCdr,
  ...jabvoxAudioAnalysis,
  ...jabvoxAnalytics,
  ...jabvoxTasks,
  ...jabvoxSaldo,
  ...jabvoxAiBudget,
  ...jabvoxSms,
  ...jabvoxIpWhitelist,
  ...jabvoxAiChat,
  ...jabvoxProvisioningChat,
  ...jabvoxManagementStates,
  ...jabvoxDialer,
  ...jabvoxFieldSecurity,
  ...jabvoxContacts,
  ...jabvoxLeads,
  ...jabvoxAffiliates,
  ...jabvoxAffiliatePortal,
  ...jabvoxCalendar,
  ...jabvoxInternalChat,
  ...jabvoxReports,
  ...jabvoxEmail,
  ...jabvoxActions,
  ...jabvoxBilling,
  ...jabvoxForms,
  ...jabvoxCustomization,
  ...jabvoxClickToCall,
  ...jabvoxSoftphone,
  ...jabvoxWhatsappTemplates,
  ...jabvoxWhatsappFlows,
  ...jabvoxBulkWhatsapp,
  ...jabvoxWhatsappGroups,
  ...jabvoxVoiceBroadcast,
  ...jabvoxTickets,
  ...jabvoxLeadImport,
  ...jabvoxDataExport,
  ...jabvoxAdvancedAutomations,
  ...jabvoxClinica,
};
